import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import { SeoExam, SeoSpecialty } from '@medprev-web-app/api-graphql-client';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons';

import CtaModalNotifyMe from '@/app/(main)/(pages)/(institucional)/(index)/_components/cta/modals/cta-modal-notify-me.component';
import { Place } from '@/types/google-maps.types';
import { useModal } from '@/hooks/use-modal.hook';
import { Button } from '@/components/ui/button/button.component';

interface CtaProcedureNotifyMeButtonProps {
  procedure?: SeoSpecialty | SeoExam | null;
  place: Pick<Place, 'state' | 'city'>;
}

export function CtaProcedureNotifyMeButton({ procedure, place }: CtaProcedureNotifyMeButtonProps) {
  const { open: isNofityMeModalOpen, onOpenChange: setIsOpenNotifyMeModal }
    = useModal();

  const onClickHasNoBranches = () => {
    setIsOpenNotifyMeModal(true);
  };

  return (
    <>
      <Button
        data-testid={DataTestIdEnum.SEO_CTA_SCHEDULE_NO_BRANCH_BUTTON}
        onClick={onClickHasNoBranches}
        className="h-12"
        startIcon={faChevronDown}
      >
        Quero ser avisado
      </Button>

      <CtaModalNotifyMe
        open={isNofityMeModalOpen}
        onOpenChange={setIsOpenNotifyMeModal}
        procedure={procedure}
        place={place}
      />
    </>
  );
}
